import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  templateUrl: './failures-dialog.component.html'
})
export class FailuresDialogComponent implements OnInit {
  orderId: number;
  failures = [];
  loading: boolean;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<FailuresDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.orderId = +data.id;
    this.loading = true;
  }

  public async ngOnInit(): Promise<any> {
    await this.initFailures();
  }

  async initFailures() {
    try {
      this.loading = true;
      this.failures = await this.commonService.getList(`unloading_command/web/quality_failures/${this.orderId}`) as any;

      for (const failure of this.failures) {
        failure.selected = !!failure.id;
      }

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.matDialogRef.close();
  }

  checkBoxChanged(failure: any) {
    failure.selected = !failure.selected;
  }

  async submitFailures() {
    const failures = this.failures.filter(failure => failure.selected);
    const sendFailures = [];
    for (const failure of failures) {
      sendFailures.push(failure.quality_failure_id);
    }
    try {
      await this.commonService.updateObject(`unloading_command/web/quality_failures/${this.orderId}`, sendFailures);
      this.close();
      this.toastMessagesService.toastMessages('Επιτυχής καταχώρηση');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
